import React, {useEffect, useState} from 'react';
import {  Input, Button} from 'reactstrap';
import CpmCommPFindTarget from './CpmCommPFindTarget';

/**
 *
 * User : YUJIN
 * Date : 2023.11.22
 * @ file : Components/Common/CpmCommTargetInput.js
 * @ Desc : target Component
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {boolean} isDisabled - disabled 여부
 * @param {boolean} essential - 필수 여부
 */
const CpmCommTargetInput = ({
                                params,
                                setParams,
                                isDisabled= false ,
                                essential = false,
                            }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false); // 모달 열림 여부

    // 부모의 파라미터에 props 세팅
    const setParam = (props) => {
        setParams({...params, ...props});
    }

    // 부모의 파라미터 타겟 이름, 아이디 초기화
    const initParams = () => {
        setParam({tgId: '', tgStr: '', tgAreaCd : '50'});
    }


    // 모달 열림 제어 함수
    const handleModal = () => {
        setModalIsOpen(!modalIsOpen);
    }

    // 타겟 아이디 세팅 함수
    const onChangeTargetId = (e) => {
        initParams();
        handleModal()  ;
    }

    // 타겟 이름, 아이디 세팅 함수
    const onChangeParams = (value) => {
        setParam({tgId: value.tgId, tgStr: value.tgStr, tgAreaCd : value.tgAreaCd });
    }


    useEffect(() => {
        setParam({tgId : params.tgId, tgStr : params.tgStr, tgAreaCd : params.tgAreaCd||'50'  })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const modalProps = {
        params ,
        setParam ,
        modalIsOpen,
        handleModal,
        onChangeParams
    }
    return (
        <>
            <div className="d-flex  align-items-center">
                <Input className={`${essential && 'essential'} form-control-sm me-2`}
                       name="타겟"
                       id="tgStr"
                       value={params?.tgStr || ''}
                       onKeyPress={onChangeTargetId}
                       onChange={onChangeTargetId}
                       onFocus={( e ) => e.target.select()}
                       disabled={isDisabled}
                       maxLength={800}
                       autoComplete="off"/>
                { ! isDisabled &&
                    <Button color="primary"
                            size="sm"
                            style={{ width : "70px" , borderColor : "#a9a8a8"}}
                            className={"px-0  "}
                            disabled={isDisabled}
                            onClick={() => isDisabled ? null : [handleModal()]}> 타겟선택 </Button>
                }
            </div>
            <CpmCommPFindTarget {...modalProps}/>
        </>
        ) };

        export default CpmCommTargetInput;